/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { queryVCode, register, setCurrentKey } from './store';

export const RegisterForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { disabled, vcodeConfig } = useSelector((state) => state.loginModalReducer);

  useEffect(() => {
    handleQueryVCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQueryVCode = () => {
    dispatch(queryVCode());
  };

  const handleRegister = async (formValue) => {
    dispatch(register(formValue, vcodeConfig));
  };

  const handleLoginButtonClick = () => {
    dispatch(setCurrentKey(1));
  };

  return (
    <div className="form register">
      <h1 className="title">注册</h1>
      <Form onFinish={handleRegister}>
        <Form.Item rules={[{ required: true, message: '请输入用户名' }]} name="username">
          <Input placeholder="用户名" block="true" size="large" />
        </Form.Item>
        <Form.Item rules={[{ required: true, message: '请输入密码' },
        {
          pattern: /^[a-zA-Z0-9_]{6,18}$/,
          message: '请输入6-18位字母、数字组合'
        }]} name="password">
          <Input.Password placeholder="密码" block="true" size="large" />
        </Form.Item>

        <Form.Item name="vcode" rules={[{ required: true, message: '请输入验证码!' }]}>
          <Input
            size="large"
            placeholder="验证码"
            suffix={
              <img
                alt="验证码"
                onClick={handleQueryVCode}
                src={'data:image/jpeg;base64,' + vcodeConfig?.image}
              />
            }
          />
        </Form.Item>
        <Button
          className="button"
          type="primary"
          block="true"
          size="large"
          htmlType="submit"
          disabled={disabled}
        >
          注册
        </Button>
      </Form>
      <p>
        已有账号？<a onClick={handleLoginButtonClick}>登录</a>
      </p>
    </div>
  );
};
